module.exports = __webpack_public_path__ + "static/media/Produtos3.631e7027.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos3.png
// module id = 2003
// module chunks = 0